import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '../components/Sidebar.js';
import { Header } from '../components/Header.js';

const PAGE_TITLES: Record<string, string> = {
  '/templates': 'Pay Plan Templates',
  '/templates/new': 'New Template',
  '/assignments': 'Employee Assignments',
  '/pay-sheets': 'Pay Sheets',
  '/users': 'User Management',
};

function getPageTitle(pathname: string): string {
  if (pathname.includes('/templates/') && pathname.includes('/edit')) {
    return 'Edit Template';
  }
  return PAGE_TITLES[pathname] ?? 'Pay Plan Manager';
}

export function AppLayout(): React.JSX.Element {
  const location = useLocation();
  const title = getPageTitle(location.pathname);

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar />
      <div className="ml-64">
        <Header title={title} />
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
